import { render } from "./SmsScheduled.vue?vue&type=template&id=36c28ab2&scoped=true"
import script from "./SmsScheduled.vue?vue&type=script&lang=js"
export * from "./SmsScheduled.vue?vue&type=script&lang=js"

import "./SmsScheduled.vue?vue&type=style&index=0&id=36c28ab2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c28ab2"]])

export default __exports__